<!-- 产品解决方案／群星金融N+1供应链金融产品 -->
<template>
  <div id="service">
    <header>
      <div class="cover">
        <h1>
          供应链金融服务
          <span>成本和收益
            <div class="dialog">
              <h3>核心无需实际承担财务费用，由现金折扣获得的收益来覆盖</h3>
              <p>资金方和平台是需要收取利息手续费的。那这部分钱谁出呢？以现金采购方案为例，供应商在选择提早拿到货款时可以给核心企业打个折扣。利息和手续费可以根据实际情况，由核心和供应商进行商谈。</p>
              <h4>举个例子：</h4>
              <h5><i>假设供应商愿意给到的折扣是95折。</i><br><i>即100块钱的货款，供应商支付给核心5元的成本，换取3个月的账期。</i><br><i>而核心企业的需要支付给资金方和平台的费率是年化10%。</i><br><i>核心成本：95*10%/12*3=2.375元。</i><br><i>所以说在支付完资金方和平台费用之后，核心还有收益2.625元。</i></h5>
              <p>综上，在现金采购方案中核心<strong>无需承担任何实际成本</strong>。同时供应商也满足了自己的诉求。</p>
            </div>
          </span>
        </h1>
        <h2>每个企业及其供应商都是独一无二的。因此，您的供应链金融方案的要求和计划执行也将是独一无二的。<br>群星会提供灵活，可扩展的解决方案，<br>根据您的营运资金目标量身定制，同时支持上下游供应商／经销商的应收账款转让服务。</h2>
        <ul>
          <li><img src="/imgs/portal/products/zijin_2@2x.png" alt="icon">资金方案<div class="hover-show">资金方案服务<span>群星利用自身的资源和专业化能力，依据核心企业的需求、市场状况，设计产业链融资方案，并结合上述大数据分析筛选的结果，为核心企业在市场上寻找匹配的资金合作渠道，确定与资金合作渠道的合作流程、价格、设计方案。</span></div></li>
          <li><img src="/imgs/portal/products/data_2@2x.png" alt="icon">数据分析<div class="hover-show">数据分析服务<span>群星金融运用大数据分析系统、机器学习、人工智能等新技术，对核心企业提供的应付账款进行准确分类、应用量化模型，筛选出可提供融资服务的上游企业准入清单，测算出相关的风险控制参数（如授信额度等）</span></div></li>
          <li><img src="/imgs/portal/products/lianshu_2@2x.png" alt="icon">链属营销<div class="hover-show">链属营销服务<span>依托互联网营销平台和社会化营销工具，群星金融提供快速高效的产业链融资信息传播、客户营销服务，从而给核心企业创造最大的价值。</span></div></li>
          <li><img src="/imgs/portal/products/line_2@2x.png" alt="icon">线上平台<div class="hover-show">线上平台服务<span>群星依托其自动化运营系统为用户提供全程电子化、自动化运营操作功能（包括认证、签约、融资申请、融资发放、还款核销、资金监管等），以帮助核心企业及其上游供应商快速便捷地从资金方获得融资服务。</span></div></li>
        </ul>
      </div>
    </header>
    <section>
      <div class="cover">
        <h1>群星金融白皮书<span>无论您的公司是供应链金融新手还是熟悉流程，我们的白皮书都可以为您提供更多信息，帮助您提高供应链金融方案的成功率。</span></h1>
        <a class="file" href="/pdf/portal/群星金融产品白皮书.zip">
          <span>下载白皮书</span>
          <img src="/imgs/portal/home/download@2x.png" alt="icon">
        </a>
      </div>
    </section>
    <portal-footer></portal-footer>
  </div>
</template>

<script>
import Footer from '../Footer'

export default {
  created () {
  },
  components: {
    'portal-footer': Footer
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "~@/assets/css/utils";
@import "../../css/theme-config";

#service{
  margin-top: 96px;
  background:#f2f2f2;
  header{
    height: 600px;
    background: url(/imgs/portal/products/bg@2x.png) center center no-repeat;
    background-size: cover;
    color:#ffffff;
    .cover{
      width: 1000px;
      margin: 0 auto;
      h1{
        font-weight: normal;
        font-family:PingFangSC-Regular;
        font-size:24px;
        color:#ffffff;
        letter-spacing:0.5px;
        line-height:24px;
        text-align:left;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);
        padding-bottom: 10px;
        margin: 0;
        padding-top: 24px;
        span{
          float: right;
          display: block;
          font-family:PingFangSC-Regular;
          font-size:14px;
          color:#ffffff;
          letter-spacing:0.5px;
          text-align:right;
          line-height:14px;
          margin-top: 5px;
          padding: 3px 0 3px 26px;
          background: url(/imgs/portal/products/attention@2x.png) left center no-repeat;
          background-size: 20px;
          cursor: pointer;
          position: relative;
          .dialog{
            display: none;
            position: absolute;
            right: 0;
            top: 30px;
            z-index: 1;
            color:#333333;
            opacity:0.96;
            background:#ffffff;
            border-radius:4px;
            width:528px;
            height:350px;
            text-align: left;
            padding: 42px 49px 40px;
            box-sizing: border-box;
            h3{
              font-family:PingFangSC-Medium;
              font-size:16px;
              letter-spacing:0.5px;
              line-height:16px;
              font-weight: 600;
              margin: 0 0 20px;
            }
            p{
              font-family:PingFangSC-Regular;
              font-size:12px;
              letter-spacing:0.38px;
              text-align:justify;
              line-height:18px;
              margin: 0;
            }
            h4{
              margin: 10px 0 0;
              padding: 3px 0 6px;
              font-family:PingFangSC-Medium;
              font-size:14px;
              color:#1f5dea;
              letter-spacing:0.44px;
              line-height:16px;
              text-align:left;
              padding-left: 23px;
              background: url(/imgs/portal/products/example@2x.png) -12px center no-repeat;
              background-size: 37px;
            }
            h5{
              margin: 0;
              font-family:PingFangSC-Regular;
              color:#41434b;
              text-align:justify;
              font-weight: normal;
              overflow: hidden;
              i{
                font-style: normal;
                font-size:12px;
                background: #DFE9FF;
                letter-spacing:0.38px;
                display: block;
                float: left;
                margin-bottom: 6px;
              }
            }
            strong{
              color:#1f5dea;
              margin-top: 12px;
              display: inline-block;
            }
          }
          &:hover .dialog{
            display: block;
          }
        }
      }
      h2{
        font-family:PingFangSC-Regular;
        font-size:18px;
        color:#ffffff;
        letter-spacing:0.43px;
        text-align:center;
        line-height:28px;
        margin: 50px 0 58px;
        font-weight: normal;
      }
      ul{
        overflow: hidden;
        height: 308px;
        li{
          width: 229px;
          height: 250px;
          float: left;
          margin-right: 28px;
          box-shadow: 0 29px 40px 0 rgba(0, 0, 0, 0.5);
          border-radius:4px;
          font-family:PingFangSC-Regular;
          font-size:21px;
          color:#ffffff;
          letter-spacing:0.75px;
          text-align:center;
          line-height:21px;
          position: relative;
          cursor: pointer;
          img{
            display: block;
            margin: 65px auto 29px;
          }
          &:hover .hover-show{
            opacity:0.9;
          }
          .hover-show{
            position: absolute;
            left: 0;
            top: 0;
            opacity:0;
            background:#1f5dea;
            border-radius:4px;
            width:229px;
            height:250px;
            font-family:PingFangSC-Regular;
            color:#ffffff;
            letter-spacing:0.66px;
            line-height:20px;
            text-align: center;
            font-size:21px;
            padding: 38px 30px 0;
            box-sizing: border-box;
            transition: opacity 0.5s;
            span{
              font-size:12px;
              text-align:justify;
              display: block;
              margin-top: 20px;
            }
          }
        }
        li:nth-child(1){
          background: url(/imgs/portal/products/zijin_bg@2x.png) center center no-repeat;
          background-size: 100% 100%;
          img{
            width: 53px;
          }
        }
        li:nth-child(2){
          background: url(/imgs/portal/products/data_bg@2x.png) center center no-repeat;
          background-size: 100% 100%;
          img{
            width: 61px;
          }
        }
        li:nth-child(3){
          background: url(/imgs/portal/products/lianshu_bg@2x.png) center center no-repeat;
          background-size: 100% 100%;
          img{
            width: 77px;
          }
        }
        li:nth-child(4){
          background: url(/imgs/portal/products/line_bg@2x.png) center center no-repeat;
          background-size: 100% 100%;
          margin-right: 0;
          img{
            width: 79px;
          }
        }
      }
    }
  }
  section{
    background: #ffffff;
    .cover{
      width: 1000px;
      margin: 0 auto;
      padding: 50px 0;
      overflow: hidden;
    }
    h1{
      margin: 0 125px 0 30px;
      width: 603px;
      float: left;
      font-family:PingFangSC-Semibold;
      font-size:36px;
      color:#333333;
      letter-spacing:1.5px;
      line-height:40px;
      text-align:left;
      span{
        display: block;
        font-family:PingFangSC-Regular;
        font-size:14px;
        letter-spacing:0.44px;
        text-align:justify;
        line-height:24px;
        margin-top: 8px;
        font-weight: normal;
      }
    }
    .file{
      background:#1f5dea;
      border-radius:4px;
      width:215px;
      height:58px;
      font-family:PingFangSC-Regular;
      font-size:22px;
      color:#ffffff;
      letter-spacing:0;
      text-align:center;
      line-height:22px;
      float: left;
      margin-top: 21px;
      box-sizing: border-box;
      overflow: hidden;
      padding: 18px 22px;
      cursor: pointer;
      span,img{
        display: block;
        float: left;
      }
      span{
        padding-right: 20px;
        border-right: 1px solid rgba(255, 255, 255, 0.2);
      }
      img{
        width: 16px;
        margin: 3px 0 0 20px; 
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Service.vue?f75615e0